import React, { useState } from "react";
import { Row, Col, Image, Button, ButtonGroup } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import GalleryImage from "./galleryImage.jsx";

import rpGalleryData from "../localdata/rpGallery.json";

const demoImages = [
  '/images/gallery/rp/wdlf/pony.jpg',
  '/images/gallery/rp/wdlf/redApe.jpg',
  '/images/gallery/rp/cats/tabby.jpg',
  '/images/gallery/rp/wdlf/shires.jpg'
];

const categories = [
  {
    "title": "Dogs",
    "filter": "dogs"
  },
  {
    "title": "Cats",
    "filter": "cats"
  },
  {
    "title": "Wildlife",
    "filter": "wdlf"
  },
  {
    "title": "Pencil",
    "filter": "pncl"
  },
  {
    "title": "Ink",
    "filter": "ink"
  }
];

const customModalStyle = {
  overlay: {zIndex: 9000}
};

  
export default function RussellPrints() {

  // Light Gallery Modal
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setOpen] = useState(false);

  const galleryClickHandler = (index) => {
    setOpen(true);
    setPhotoIndex(index);
  }

  const [filter, setFilter] = useState('dogs');

  const filterChangeHandler = (e) => {
    setFilter(e.target.id);
  }
 
  const images = rpGalleryData.filter(item => item.filter === filter);

  return (
          <React.Fragment>
            <Row>
              <Col className="mb-4">
                <h3>Russell Prints</h3>
              </Col>
            </Row>
            <Row> 
              <Col md={12} lg={6} xl={6} className="mb-4">
                <p>Scraperboard is mainly used in commercial art and is simply a thin layer of white clay covered by a film of black ink. By using a sharp pointed tool (my first being custom made from a nail)
                the black surface is removed to expose the white clay leaving a stark black and white image.</p>
                <p>Using tools improvised myself I took this medium to it's limits, developing a cutting technique to produce a level of detail that is hard to appreciate.</p>
              </Col>
              <Col md={12} lg={6} xl={6} className="mb-4">
                <ul className="list-group list-group-horizontal">
                  <li className="list-group-item p-2 overflow-hidden">
                    <GalleryImage index={0} src="/images/gallery/rp/ponyDetail.jpg" title="Pony" onClickHandler={ galleryClickHandler } />
                  </li>
                  <li className="list-group-item p-2 overflow-hidden">
                    <GalleryImage index={1} src="/images/gallery/rp/apeRedDetail.jpg" title="Red Ape" onClickHandler={ galleryClickHandler } />
                  </li>
                </ul>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={12} lg={6} xl={6} className="mx-auto overflow-hidden">
                <GalleryImage index={2} src="/images/gallery/rp/tabbyDetail.jpg" title="Tabby" onClickHandler={ galleryClickHandler } />
              </Col>

              <Col xs={12} md={12} lg={6} xl={6} className="mx-auto mb-5 overflow-hidden">
                <GalleryImage index={3} src="/images/gallery/rp/wdlf/shires.jpg" title="Shires" onClickHandler={ galleryClickHandler } />
                <p className="small">One of the earliest and probably the most difficult piece I attempted.</p>
              </Col>
            </Row>

            <Row>
              <Col>
                <ButtonGroup className="d-flex" aria-label="RPGallery filter button group">
                {
                  categories.map((item, i) => (
                    <Button className={item.filter === filter ? 'active' : null } variant="secondary" key={"buttonFilter_" + i} id={item.filter} onClick={ filterChangeHandler } >{item.title}</Button>
                  ))
                }
                </ButtonGroup>
              </Col>
            </Row>

            <Row className="mt-4">
            {
              images.map((item, i) => (
                <Col key={"picture_" + i} xs={4} sm={6} md={3} lg={2} xl={2} className="my-auto pb-4 overflow-hidden">
                  <Image src={"/images/gallery/rp/" + item.filter + "/" + item.filename} alt={item.title} fluid />
                </Col>
              ))
            }
            </Row>

            {isOpen && (
              <Lightbox
                reactModalStyle={ customModalStyle }
                mainSrc={ demoImages[photoIndex] }
                nextSrc={ demoImages[getNextPhotoIndex(photoIndex)] }
                prevSrc={ demoImages[getPrevPhotoIndex(photoIndex)] }
                onCloseRequest={ () => setOpen(false) }
                onMovePrevRequest={ () => setPhotoIndex(getPrevPhotoIndex(photoIndex)) }
                onMoveNextRequest={ () => setPhotoIndex(getNextPhotoIndex(photoIndex)) }
              />
            )}

          </React.Fragment>
  );

  function getNextPhotoIndex(currIndex) {
    return (currIndex + 1) % demoImages.length;
  }

  function getPrevPhotoIndex(currIndex) {
    return (currIndex - 1 + demoImages.length) % demoImages.length;
  }
}
